// import { useState, useEffect } from 'react';
import Question from './icons/Question';
// import BuyNft from './BuyNft';
import ProgressCard from './ProgressCard';
import ProgressBar from './ProgressBar';

export default function Counter({ hashconnect, pairingData, paired }) {
    // const [timeLeft, setTimeLeft] = useState("");
    // const percentage = 100;

    // useEffect(() => {
    //     const targetDate = new Date('2025-02-22T09:59:59');
    //     const updateCounter = () => {
    //         const now = new Date();
    //         const diff = targetDate.getTime() - now.getTime();

    //         if (diff <= 0) {
    //             setTimeLeft("NFT LIBERADO!");
    //             return;
    //         }

    //         const hours = Math.floor(diff / (1000 * 60 * 60));
    //         const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    //         const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    //         setTimeLeft(
    //             `${hours.toString().padStart(2, '0')}:${minutes
    //                 .toString()
    //                 .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    //         );
    //     };

    //     const intervalId = setInterval(updateCounter, 1000);

    //     return () => clearInterval(intervalId);
    // }, []);

    return (
        <div className="flex flex-col md:flex-row justify-center items-center sm:pt-[50px] gap-4 p-4 md:p-8 sm:scale-[1.1] md:scale-[0.72] lg:scale-[1] ">
            <Question />
            <div className="flex flex-col w-full md:w-[530px] h-[220px] md:h-[530px] items-center justify-between">
                <div className="flex hidden md:flex flex-col w-full h-[119px] bg-[#151220] shadow-black rounded-[12px] justify-center items-center border-[5px] border-[#655884] gap-[15px]" style={{ boxShadow: '0 2px 10px rgba(0, 0, 0, 0.5)' }}>
                    <h2 className="text-2xl md:text-48 h-[27px] text-wite-850 text-center whitespace-nowrap">Maximum of ?? NFTs</h2>
                    <h2 className="text-2xl md:text-48 h-[33px] text-wite-850 text-center">per wallet</h2>
                </div>

                <div className="flex hidden md:flex flex-row w-[530px] gap-[10px] shadow-black rounded-[12px] items-center justify-center">
                    <ProgressCard className="hidden md:block" />
                    <div className="flex flex-col w-[260px] h-[150px] bg-[#655884] rounded-[12px] items-center justify-center gap-[22px]" style={{ boxShadow: '0 2px 10px rgba(0, 0, 0, 0.5)' }}>
                        <p className="text-4xl text-white md:text-70 h-[40px] text-center">???</p>
                        <p className="text-4xl text-white md:text-70 h-[40px] text-center">HBAR</p>
                    </div>
                </div>

                <div className="flex block md:hidden h-[80px] w-[240px] bg-[#43385E] shadow-black rounded-2xl justify-center items-center p-4" style={{ boxShadow: '0 2px 10px rgba(0, 0, 0, 0.3)' }}>
                    <p className="text-60 md:text-5xl text-purple-850 text-center  mt-[5px] ">??:??:??</p>
                </div>
                
                <ProgressBar />

                <div className="flex block md:hidden w-[280px] md:flex-row gap-2 shadow-black rounded-lg items-center">
                    <ProgressCard />
                    <div className="flex block md:hidden flex-col w-[90px] h-[75px] bg-[#151220] shadow-black rounded-[12px] justify-center items-center border-[2px] border-[#655884] p-4 md:p-6" style={{ boxShadow: '0 2px 10px rgba(0, 0, 0, 0.5)' }}>
                        <h2 className="text-16 md:text-4xl h-[15px] text-wite-850 text-center whitespace-nowrap">Maximum of</h2>
                        <h2 className="text-16 md:text-4xl h-[15px] text-wite-850 text-center whitespace-nowrap">?? NFTs</h2>
                        <h2 className="text-16 md:text-4xl h-[22px] text-wite-850 text-center whitespace-nowrap">per wallet</h2>
                    </div>
                    <div className="flex flex-col w-[90px] h-[75px] bg-[#655884] shadow-black rounded-[12px] justify-center items-center" style={{ boxShadow: '0 2px 10px rgba(0, 0, 0, 0.5)' }}>
                        <span className="text-white text-32 h-[30px] md:text-70">???</span>
                        <span className="text-white text-32 h-[45px] md:text-70 md:mt-2">HBAR</span>
                    </div>
                </div>

                <div className="flex md:w-[530px] hidden md:flex md:h-[160px] bg-[#43385E] shadow-black rounded-3xl justify-center items-center" style={{ boxShadow: '0 2px 10px rgba(0, 0, 0, 0.3)' }}>
                    <p className="md:text-128 text-60 text-purple-850 text-center">??:??:??</p>
                </div>
                {/* <BuyNft hashconnect={hashconnect} pairingData={pairingData} paired={paired} /> */}
            </div>

        </div>
    );
}
